export default __webpack_public_path__ + "static/media/oracle.fee1dc96.svg";